/** Stable keys stored in API (+codes+ table +register_key+); labels are i18n. */
export const REGISTER_CODE_KEYS = {
  RAW_MATERIAL_RECEPTION: 'raw_material_reception',
  RAW_MATERIAL_STOCK_DECREASE: 'raw_material_stock_decrease',
  SUPPLY_RECEPTION: 'supply_reception',
  SUPPLY_STOCK_DECREASE: 'supply_stock_decrease',
  FINAL_PRODUCT_RECEPTION: 'final_product_reception',
  FINAL_PRODUCT_STOCK_DECREASE: 'final_product_stock_decrease',
  FINAL_PRODUCT_INCREASE: 'final_product_increase',
  FINAL_PRODUCT_ORDER: 'final_product_order',
  NON_CONFORMITY: 'non_conformity',
};

/** Rows shown in Configuración → General → Códigos */
export const REGISTER_CODE_CATEGORIES = [
  { key: REGISTER_CODE_KEYS.RAW_MATERIAL_RECEPTION, labelKey: 'category_raw_material_reception' },
  { key: REGISTER_CODE_KEYS.RAW_MATERIAL_STOCK_DECREASE, labelKey: 'category_raw_material_stock_decrease' },
  { key: REGISTER_CODE_KEYS.SUPPLY_RECEPTION, labelKey: 'category_supply_reception' },
  { key: REGISTER_CODE_KEYS.SUPPLY_STOCK_DECREASE, labelKey: 'category_supply_stock_decrease' },
  { key: REGISTER_CODE_KEYS.FINAL_PRODUCT_RECEPTION, labelKey: 'category_final_product_reception' },
  { key: REGISTER_CODE_KEYS.FINAL_PRODUCT_STOCK_DECREASE, labelKey: 'category_final_product_stock_decrease' },
  { key: REGISTER_CODE_KEYS.FINAL_PRODUCT_INCREASE, labelKey: 'category_final_product_increase' },
  { key: REGISTER_CODE_KEYS.FINAL_PRODUCT_ORDER, labelKey: 'category_final_product_order' },
  { key: REGISTER_CODE_KEYS.NON_CONFORMITY, labelKey: 'category_non_conformity' },
];

export const REGISTER_CODE_MAX_LENGTH = 32;

export const defaultRegisterCodes = () => ({
  [REGISTER_CODE_KEYS.RAW_MATERIAL_RECEPTION]: '',
  [REGISTER_CODE_KEYS.RAW_MATERIAL_STOCK_DECREASE]: '',
  [REGISTER_CODE_KEYS.SUPPLY_RECEPTION]: '',
  [REGISTER_CODE_KEYS.SUPPLY_STOCK_DECREASE]: '',
  [REGISTER_CODE_KEYS.FINAL_PRODUCT_RECEPTION]: '',
  [REGISTER_CODE_KEYS.FINAL_PRODUCT_STOCK_DECREASE]: '',
  [REGISTER_CODE_KEYS.FINAL_PRODUCT_INCREASE]: '',
  [REGISTER_CODE_KEYS.FINAL_PRODUCT_ORDER]: '',
  [REGISTER_CODE_KEYS.NON_CONFORMITY]: '',
});
